import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useCart } from "../util/CartContext";
import logo from "../assets/logo2.png";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const { getCartCount } = useCart();
  const cartCount = getCartCount();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`sm:fixed top-0 left-0 right-0 h-[17vh] w-full sm:justify-between flex transition-all duration-500 ease-in-out z-20 ${
        scrolled ? "bg-white/80 backdrop-blur-sm" : "bg-transparent"
      }`}
    >
      <img
        src={logo}
        alt="logo"
        className="scale-50 sm:h-full object-contain"
      />
      <div className="flex space-x-2 sm:space-x-4 text-white font-bold sm:justify-end items-center mr-2 sm:mr-5 h-full text-sm sm:text-lg">
        <NavLink to={"/home"} className="no-underline">
          <div
            className={`cursor-pointer m-2 px-3 py-2 rounded hover:scale-110 transition duration-300 ease-in-out ${
              scrolled
                ? "text-gray-800 hover:bg-gray-200/50"
                : "text-gray-400 hover:bg-white/20"
            }`}
          >
            Home
          </div>
        </NavLink>
        <NavLink to={"/home/about"} className="no-underline">
          <div
            className={`cursor-pointer m-2 px-3 py-2 rounded hover:scale-110 transition duration-300 ease-in-out ${
              scrolled
                ? "text-gray-800 hover:bg-gray-200/50"
                : "text-gray-400 hover:bg-white/20"
            }`}
          >
            About
          </div>
        </NavLink>
        <NavLink to={"/home/cart"} className="no-underline">
          <div
            className={`cursor-pointer m-2 px-3 py-2 rounded hover:scale-110 transition duration-300 ease-in-out relative ${
              scrolled
                ? "text-gray-800 hover:bg-gray-200/50"
                : "text-gray-400 hover:bg-white/20"
            }`}
          >
            Cart
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
                {cartCount}
              </span>
            )}
          </div>
        </NavLink>
      </div>
    </div>
  );
}

export default Header;
